import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useFoodflowDashboardStore = defineStore('foodflowDashboard', () => {
    const summary = ref(null);

    const reset = () => {
        summary.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/foodflow-dashboard', { params }),
    };

    return {
        summary,
        reset,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useFoodflowDashboardStore.acceptHMRUpdate);
}
